export const DEFAULT = 'default';
export const NAVIGATION = 'navigation';

export const UI_LOAD = 'ui.load';
export const UI_ACTION = 'ui.action';
export const UI_ACTION_TOUCH = 'ui.action.touch';

export const APP_START_COLD = 'app.start.cold';
export const APP_START_WARM = 'app.start.warm';
